import { ArrowLongRightIcon, ArrowPathIcon } from "@heroicons/react/24/solid";
import { useState, useEffect } from "react";
import { getLocalUserInfo } from "../../../../utility/authHelper";
import { getAll } from "../../../../services/reports.service";
export default function DashboardTodayCount() {
    const { counter_id, company_id } = getLocalUserInfo();
    const [saasSummryLoading, setSaasSummryLoading] = useState(false);
    const [gdsSummryLoading, setGdsSummryLoading] = useState(false);
    const [saasSummryData, setSaasSummryData] = useState({});
    const [gdsSummryData, setGdsSummryData] = useState({});

    const saasSummary = () => {
        setSaasSummryLoading(true);
        getAll("dashboard_saas_sales_summary")
            .then((data) => {
                setSaasSummryLoading(false);
                setSaasSummryData(data?.data?.data?.data?.[0]);
            })
            .catch((e) => {
                setSaasSummryLoading(false);
            });
    };
    const gdsSummary = () => {
        setGdsSummryLoading(true);
        getAll("dashboard_gds_sales_summary")
            .then((data) => {
                setGdsSummryLoading(false);
                setGdsSummryData(data?.data?.data?.data?.[0]);
            })
            .catch((e) => {
                setGdsSummryLoading(false);
            });
    };
    useEffect(() => {
        saasSummary();
        gdsSummary();
    }, []);
    return (
        <div className="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-5 gap-4">
            <div className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105">
                <div className={`p-1 bg-blue-200`}></div>
                <div className="p-4 2xl:p-8">
                    <h2 className="text-3xl font-bold text-gray-800 mb-3 flex justify-center">
                        {saasSummryLoading ? (
                            <ArrowPathIcon className="w-6 h-6 animate-spin" />
                        ) : (
                            saasSummryData?.todays_sales ?? 0
                        )}
                    </h2>
                    <p className="text-gray-800 text-center 2xl:mb-6">
                        Today's Sales Amount
                    </p>
                </div>
            </div>

            {!counter_id && (
                <>
                    <div className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105">
                        <div className={`p-1 bg-green-200`}></div>
                        <div className="p-4 2xl:p-8">
                            <h2 className="text-3xl font-bold text-gray-800 mb-3 flex justify-center">
                                {gdsSummryLoading ? (
                                    <ArrowPathIcon className="w-6 h-6 animate-spin" />
                                ) : (
                                    gdsSummryData?.todays_online_sales ?? 0
                                )}
                            </h2>
                            <p className="text-gray-800 text-center 2xl:mb-6">
                                Today's Online Sales Amount
                            </p>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105">
                        <div className={`p-1 bg-purple-200`}></div>
                        <div className="p-4 2xl:p-8">
                            <h2 className="text-3xl font-bold text-gray-800 mb-3 flex justify-center">
                                {gdsSummryLoading ? (
                                    <ArrowPathIcon className="w-6 h-6 animate-spin" />
                                ) : (
                                    gdsSummryData?.todays_online_ticket_sales ??
                                    0
                                )}
                            </h2>
                            <p className="text-gray-800 text-center 2xl:mb-6">
                                Today's Online Ticket Sales Qty.
                            </p>
                        </div>
                    </div>
                </>
            )}
            <div className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105">
                <div className={`p-1 bg-orange-200`}></div>
                <div className="p-4 2xl:p-8">
                    <h2 className="text-3xl font-bold text-gray-800 mb-3 flex justify-center">
                        {saasSummryLoading ? (
                            <ArrowPathIcon className="w-6 h-6 animate-spin" />
                        ) : (
                            saasSummryData?.todays_total_ticket_sales ?? 0
                        )}
                    </h2>
                    <p className="text-gray-800 text-center 2xl:mb-6">
                        Today's Total Ticket Sales Qty.
                    </p>
                </div>
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105">
                <div className={`p-1 bg-orange-200`}></div>
                <div className="p-4 2xl:p-8">
                    <h2 className="text-3xl font-bold text-gray-800 mb-3 flex justify-center">
                        {saasSummryLoading ? (
                            <ArrowPathIcon className="w-6 h-6 animate-spin" />
                        ) : (
                            saasSummryData?.todays_total_ticket_cancel ?? 0
                        )}
                    </h2>
                    <p className="text-gray-800 text-center 2xl:mb-6">
                        Today's Total Ticket Cancel Qty.
                    </p>
                </div>
            </div>
            {counter_id && (
                <>
                    <div className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105">
                        <div className={`p-1 bg-green-200`}></div>
                        <div className="p-4 2xl:p-8">
                            <h2 className="text-3xl font-bold text-gray-800 mb-3 flex justify-center">
                                {saasSummryLoading ? (
                                    <ArrowPathIcon className="w-6 h-6 animate-spin" />
                                ) : (
                                    saasSummryData?.todays_total_cancellation_earn ??
                                    0
                                )}
                            </h2>
                            <p className="text-gray-800 text-center 2xl:mb-6">
                                Earn from Cancellation
                            </p>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105">
                        <div className={`p-1 bg-purple-200`}></div>
                        <div className="p-4 2xl:p-8">
                            <h2 className="text-3xl font-bold text-gray-800 mb-3 flex justify-center">
                                {saasSummryLoading ? (
                                    <ArrowPathIcon className="w-6 h-6 animate-spin" />
                                ) : (
                                    saasSummryData?.todays_deposit ?? 0
                                )}
                            </h2>
                            <p className="text-gray-800 text-center 2xl:mb-6">
                                Today's Deposit Amount
                            </p>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
